import React from 'react';
import PropTypes from 'prop-types';
import RecommendationsProductList from '../RecommendationsProductList';

const YouMayAlsoLikeCarousel = ({
    messages,
    recommendations,
    colourPartNumber,
    tracking,
    isCarouselVisible,
    isFullWidth,
    addToCart,
    isWithAddToBag,
    className,
    useDefaultCarouselIndex,
    withQuickAdd,
    variation,
    reducedMode,
    carouselConfig,
    viewSimilarAndShopMore,
}) => {
    return (
        <RecommendationsProductList
            carouselConfig={carouselConfig}
            messages={messages}
            heading={reducedMode ? messages.soldOutReducedPage.heading : messages.youMayAlsoLike.heading}
            colourPartNumber={colourPartNumber}
            recommendations={recommendations.YMAL_ProductRec}
            onClick={tracking.ymal}
            isCarouselVisible={isCarouselVisible}
            type={'ymal'}
            tracking={tracking}
            isFullWidth={isFullWidth}
            addToCart={addToCart}
            isWithAddToBag={isWithAddToBag}
            className={className}
            useDefaultCarouselIndex={useDefaultCarouselIndex}
            withQuickAdd={withQuickAdd}
            variation={variation}
            reducedMode={reducedMode}
            viewSimilarAndShopMore={viewSimilarAndShopMore}
        />
    );
};

export default YouMayAlsoLikeCarousel;

YouMayAlsoLikeCarousel.propTypes = {
    messages: PropTypes.shape({
        wearItWith: PropTypes.shape({
            heading: PropTypes.func.isRequired,
        }).isRequired,
        youMayAlsoLike: PropTypes.shape({
            heading: PropTypes.func.isRequired,
        }).isRequired,
    }),
    recommendations: PropTypes.object,
    colourPartNumber: PropTypes.string.isRequired,
    tracking: PropTypes.shape({
        ymal: PropTypes.func,
    }),
    isCarouselVisible: PropTypes.bool,
    isFullWidth: PropTypes.bool,
    addToCart: PropTypes.func,
    isWithAddToBag: PropTypes.bool,
    className: PropTypes.string,
    useDefaultCarouselIndex: PropTypes.bool,
    withQuickAdd: PropTypes.bool,
    variation: PropTypes.string,
    reducedMode: PropTypes.bool,
    carouselConfig: PropTypes.object,
    viewSimilarAndShopMore: PropTypes.element,
};
